import { render } from "./ulockUser.vue?vue&type=template&id=8986d534&scoped=true"
const script = {}

import "./ulockUser.vue?vue&type=style&index=0&id=8986d534&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8986d534"]])

export default __exports__